import { TileSize } from "game-common/models"
import { Rectangle } from "pixi.js"

// The hover/hit region for an interactable marker, given the bounds of what it actually draws (null
// when it draws nothing measurable).
//
// Always at least a centered one-tile box: some interactive markers draw their real art in the
// TILEMAP and keep a blank/invisible sprite of their own (the V2 chest, spriteId "blank-32x32.png",
// centered on its tile), so their art bounds are empty or sit off the visible object. That floor
// keeps them hoverable and matches the box the renderer used before, so nothing that worked can
// regress to un-hoverable.
//
// Kept in its own module, free of pixi's render graph, so it can be tested: basic_sprite.ts sits in
// an import cycle (basic_sprite -> sprite_shatter -> PixiJsClientRenderer -> entity_rendering_manager
// -> sign_sprite -> basic_sprite) that throws if a test enters the graph at basic_sprite.
export const clickAreaFor = (artBounds: Rectangle | null): Rectangle => {
    let x1 = -TileSize / 2
    let y1 = -TileSize / 2 + TileSize * 0.15
    let x2 = x1 + TileSize
    let y2 = y1 + TileSize

    // Union in the art so objects drawn larger/taller/offset from one tile (the campfire, whose
    // sprite is centered via the "-texture.width/2" shift) get a region that matches what you see.
    if (artBounds && artBounds.width > 0 && artBounds.height > 0) {
        x1 = Math.min(x1, artBounds.x)
        y1 = Math.min(y1, artBounds.y)
        x2 = Math.max(x2, artBounds.x + artBounds.width)
        y2 = Math.max(y2, artBounds.y + artBounds.height)
    }

    return new Rectangle(x1, y1, x2 - x1, y2 - y1)
}
